import React, { useState, useEffect } from "react";
import "./remove-stripe-account.scss";
import { GSForm, GSSidePanelPage, GSInfoGroup, GSField } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { removeItemForm, getRemoveTitle } from "../../forms/DeleteForm";

import {
  selectCurrentOrganization,
  removeOrganizationStripeAccount,
  clearNotifications,
  selectOrganizationNotifications,
} from "../../reducers/organizationSlice";

const RemoveStripeAccount = () => {
  const [isValid, setIsValid] = useState(false);
  const selectedOrganization = useSelector(selectCurrentOrganization);
  const orgNotifications = useSelector(selectOrganizationNotifications);
  const dispatch = useDispatch();
  const navigate = useNavigate();



  const removeStripeAccount = () => {
    if(selectedOrganization?.stripeId) {
      setIsValid(false);
      dispatch(removeOrganizationStripeAccount(selectedOrganization.id));
    }
  }

  const leftNavigation = () => {
    navigate(-1);
  };

  useEffect(() => {
    if(selectedOrganization?.stripeId) {
      setIsValid(true);
    } else if (selectedOrganization && !selectedOrganization.stripeId) {
      // this allows for it to automatically go back to the previous page if stripe account successfully removed
      navigate(-1)
    }
  }, [selectedOrganization?.stripeId, navigate, selectedOrganization]);

  const getActions = () => {
    let actions = [
      {
        name: "disconnect",
        action: removeStripeAccount,
        isDisabled: !isValid,
        type: "red",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Disconnect Stripe Account",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getInfoGroup = (stripeId) => {
    const group = [
      {
        fit: "stretch",
        sections: [
          {
            sectionItems: [
              { type: "secondary", value: <GSField label="stripe account" value={stripeId} /> },
            ],
          },
        ],
      },
    ];
    
    return group;
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={getRemoveTitle("Disconnect Stripe Account")}
        formSections={
          removeItemForm("stripe account",
          <GSInfoGroup dataGroups={getInfoGroup(selectedOrganization?.stripeId)} />,
          "disconnect",
          `Are you sure you want to disconnect this Stripe account? ${selectedOrganization?.isEscrowAccount ? "This cannot be undone" : "Online registration for all tournaments will be disabled"}.`
        )}
      />
    );
  };
  
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    if (hasNotifications(orgNotifications)) {
      return {
        notifications: orgNotifications.map((n) => ({
          ...n,
          pageActions: getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };

  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "Back to details",
        size: "secondary",
        actionClick: leftNavigation,
      },
    ];
  };

  return (
    <remove-stripe-account>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </remove-stripe-account>
  );
};

export default RemoveStripeAccount;
